import { render } from "./SpecialsPage.vue?vue&type=template&id=4810bbe6&scoped=true"
import script from "./SpecialsPage.vue?vue&type=script&lang=js"
export * from "./SpecialsPage.vue?vue&type=script&lang=js"

import "./SpecialsPage.vue?vue&type=style&index=0&id=4810bbe6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4810bbe6"

export default script